export const calcRating = (rating: number): number => {
  const roundedRating = Math.round(rating);
  const diff = rating - roundedRating;
  if (diff > 0.25 && diff < 0.75) {
    return roundedRating + 0.5;
  }
  if (diff > 0.75) {
    return roundedRating + 1;
  }
  if (rating < 0.25 && rating > 0) {
    return 0.25;
  }

  return roundedRating;
};

export const calcAGDrating = (rating: number) => {
  if (rating === -1) {
    return 0;
  }
  const roundedRating = Math.round(rating);
  const diff = rating - roundedRating;
  if (diff === 0.25) {
    return roundedRating;
  }
  return Math.round(rating * 2) / 2;
};
